import React from 'react';
import dayjs from 'dayjs';
import { QUANTITY } from '@Apis/constants';
import HideValue from '../../../Common/RestrictedAccess/HideValue';

const ListScreenKeys = ({ documentData, MONEY, priceMasking }) => {
  const record = documentData;

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const expiryMoment = dayjs(dayjs(record?.expiry_date).format('YYYY-MM-DD'));
  let shelfLife = 0;
  if (dayjs().isSameOrBefore(expiryMoment)) {
    shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
  }
  // eslint-disable-next-line prefer-const
  let shelfLifePct = Math.round(((shelfLife / record?.expiry_days) * 100));

  const toProperCase = (text) => {
    return text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  let infoArray = [
    {
      label: 'PRODUCT',
      value: `#${record?.internal_sku_code} ${record?.ref_product_code ? `${record?.ref_product_code} - ` : ''}${record?.product_sku_name}`,
    },
    {
      label: 'LOCATION',
      value: `${record?.tenant_name} ${record?.department_name}`,
    },
    {
      label: 'BATCH #',
      value: record?.custom_batch_number ? record.custom_batch_number : record?.batch_number,
    },
    {
      label: 'ON HAND',
      value: `${QUANTITY(record?.available_qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`,
    },
    {
      label: 'RESERVED',
      value: `${QUANTITY(record?.reserved_qty - record?.consumed_qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`,
    },
    {
      label: 'ORDER',
      value: record?.reservation_entity_number || '-',
    },
    {
      label: 'COST PRICE',
      value: (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view cost price" /> : MONEY(record?.cost_price),
    },
    {
      label: 'LANDED COST',
      value: (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view landed cost" /> : MONEY(record?.landed_cost),
    },
    {
      label: 'AR NUMBER',
      value: record?.ar_number ? record?.ar_number : '-',
    },
    {
      label: 'QUALITY',
      value: `${!record?.is_rejected_batch ? 'Good' : 'Bad'}`
      ,
    },
    {
      label: 'EXPIRY',
      value: shelfLife !== 0 ? (record?.expiry_date === '2099-01-01' ? 'No expiry' : `${shelfLife} Days (${shelfLifePct > 100 ? 100 : shelfLifePct}%)`) : `Expired on ${dayjs(record?.expiry_date).format('DD MMM, YY')}`,
    },
    {
      label: 'BATCH INWARD DATE',
      value: record?.batch_inward_date ? dayjs(record?.batch_inward_date).format('DD/MM/YYYY') : '-',
    },
    {
      label: 'COST PRICE',
      value: (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view cost price" /> : MONEY(record?.cost_price)
    },
    {
      label: 'SELLING PRICE',
      value: (isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view selling price" /> : MONEY(record?.selling_price)
    },
    {
      label: 'MFG DATE',
      value: record?.manufacturing_date ? dayjs(record?.manufacturing_date).format('DD/MM/YYYY') : '-',
    },
    {
      label: 'LOCATION',
      value: record?.inventory_location_path || '-',
    }
  ];

  return infoArray.map(item => ({
    ...item,
    label: toProperCase(item.label),
  }))
};

export default ListScreenKeys;